/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlannerActiveTurnResponse
 */
export interface PlannerActiveTurnResponse {
    /**
     * 
     * @type {string}
     * @memberof PlannerActiveTurnResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerActiveTurnResponse
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerActiveTurnResponse
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof PlannerActiveTurnResponse
     */
    sequenceStartIndex: number;
    /**
     * 
     * @type {string}
     * @memberof PlannerActiveTurnResponse
     */
    leaseExpiresAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerActiveTurnResponse
     */
    startedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerActiveTurnResponse
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerActiveTurnResponse
     */
    updatedAt: string;
}

/**
 * Check if a given object implements the PlannerActiveTurnResponse interface.
 */
export function instanceOfPlannerActiveTurnResponse(value: object): value is PlannerActiveTurnResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('sequenceStartIndex' in value) || value['sequenceStartIndex'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function PlannerActiveTurnResponseFromJSON(json: any): PlannerActiveTurnResponse {
    return PlannerActiveTurnResponseFromJSONTyped(json, false);
}

export function PlannerActiveTurnResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerActiveTurnResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
        'message': json['message'],
        'sequenceStartIndex': json['sequence_start_index'],
        'leaseExpiresAt': json['lease_expires_at'] == null ? undefined : json['lease_expires_at'],
        'startedAt': json['started_at'] == null ? undefined : json['started_at'],
        'createdAt': json['created_at'],
        'updatedAt': json['updated_at'],
    };
}

export function PlannerActiveTurnResponseToJSON(json: any): PlannerActiveTurnResponse {
    return PlannerActiveTurnResponseToJSONTyped(json, false);
}

export function PlannerActiveTurnResponseToJSONTyped(value?: PlannerActiveTurnResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'message': value['message'],
        'sequence_start_index': value['sequenceStartIndex'],
        'lease_expires_at': value['leaseExpiresAt'],
        'started_at': value['startedAt'],
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

